import { useTranslation } from 'react-i18next';
import { StyleSheet, View } from 'react-native';
import { TextInput } from 'react-native-paper';
import { Colors } from '../../themes';
import { DebouncedTextInput } from '../forms';

type LabelSearchInputProps = {
  value: string;
  onChangeText: (text: string) => void;
  placeholder?: string;
};

export const LabelSearchInput: React.FC<LabelSearchInputProps> = ({
  value,
  onChangeText,
  placeholder,
}) => {
  const { t } = useTranslation();

  return (
    <View style={styles.searchContainer}>
      <DebouncedTextInput
        debounceTimeMs={500}
        debounceLength={3}
        debounceFunc={() => {}}
        placeholder={placeholder || t('activity.filter.searchLabels')}
        value={value}
        onBlur={() => {}}
        onChangeText={onChangeText}
        left={<TextInput.Icon icon="magnify" color={Colors.grayFill} />}
        right={
          value ? (
            <TextInput.Icon
              icon="close"
              size={20}
              color={Colors.black}
              onPress={() => onChangeText('')}
            />
          ) : (
            <View />
          )
        }
        height={44}
        disableInnerStyle={true}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  searchContainer: {
    borderBottomWidth: 0,
    marginBottom: 8,
    paddingHorizontal: 12,
    paddingVertical: 8,
  },
});
